import {useDebugValue} from 'react';

import {undef, runHPPrePopulateCookieExperiment} from '../../../utils';

import {useValues} from './';

const defaultValues = {
    destination: null,
    destinationUuid: undef,
    subDestination: null,
    listingProps: null
};

function useDestinationValues(props, cookies, system) {
    const {
        destinationValues: propsValues
    } = props;

    let {
        destinationValues: cookiesValues
    } = cookies;

    cookiesValues = runHPPrePopulateCookieExperiment(cookies, system) ? {} : cookiesValues;

    const {
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    } = useValues(defaultValues, cookiesValues, propsValues);

    const result = {
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useDestinationValues};
